import { Dimension, DimensionProperty } from './analytics-api/schema.model';

export class FilterSource {
  dimension: Dimension;
  dimensionProperty?: DimensionProperty;
  optgroup?: string;

  constructor(dimension: Dimension, dimensionProperty?: DimensionProperty, optgroup?: string) {
    if (dimension) {
      this.dimension = dimension;
    }
    if (dimensionProperty) {
      this.dimensionProperty = dimensionProperty;
    }
    if (!!optgroup) {
      this.optgroup = optgroup;
    }
  }

  public get dimensionName(): string {
    return this.isDimensionProperty ?  this.dimensionProperty?.dimensionName : this.dimension?.name;
  }

  public get name(): string {
    return this.isDimensionProperty ? this.dimensionProperty?.name : this.dimension?.name;
  }

  public get isSearchable(): boolean {
    return this.isDimensionProperty ? this.dimensionProperty?.isSearchable : this.dimension?.isSearchable;
  }

  public get displayName(): string {
    return this.isDimensionProperty ? `${this.dimension.displayName} ${this.dimensionProperty.displayName}` : this.dimension.displayName as string;
  }

  public get key(): string {
    if (this.isDimensionProperty) {
      return `${this.dimension.name}.${this.name}`;
    } else if (this.dimension.hasProperties) {
      return `${this.name}.${this.name}`;
    } else {
      return `${this.name}`;
    }
  }

  public get isDimensionProperty(): boolean {
    return !!this.dimensionProperty;
  }
}
